export function elementHasParentQuerySelector (element: HTMLElement | null, querySelector: string, maxRecursion: number = 5) {
  const checkElement = (recursionCount = 0): boolean => {
    if (!element) {
      return false;
    }
    if (element.matches(querySelector)) {
      return true;
    }
    element = element.parentElement;
    return recursionCount < maxRecursion ? checkElement(recursionCount + 1) : false;
  };

  return checkElement();
}
